import React, { useEffect } from 'react';
import InputYesNo from './Blocks/InputYesNo';
import Input4options from './Blocks/Input4options';
import InputWrittenAnswer from './Blocks/InputWrittenAnswer';
import QuestionView from './Blocks/QuestionView';
import AudioSelectPlay from './Blocks/AudioSelectPlay';

const Question = ({ handleAnswer, question, questions, answerStatus, quiz, area, onComplete, setCurrentSpinnerQuestion }) => {


    /*
        useEffect(() => {

            if (quiz.type === 'yesNo') { return; }
            if (quiz.type === '4options' && quiz.x3) { return; }

            if (answerStatus && question.audio1) {

                const audio = new Audio(question.audio1);
                audio.play().catch((e) => console.error('Chyba při přehrání audia:', e));
            }
        }, [answerStatus, question.audio]);
    */


    useEffect(() => {

        if (quiz.type === 'yesNo') return;


        const audios = [question.audio1, question.audio2, question.audio3]
            .filter(audio => !!audio) // vyfiltruj pouze existující
            .map(src => new Audio(src));
        //   console.log('question', question);
        //  console.log('audios', audios);
        if (answerStatus === 'correct' && audios.length > 0) {
            let index = 0;

            const playNext = () => {
                if (index < audios.length) {
                    //       console.log('SOUND '+index);
                    audios[index].play()
                        .then(() => {
                            audios[index].addEventListener('ended', () => {
                                index++;
                                playNext();
                            }, { once: true });
                        })
                        .catch((e) => {
                            console.error('Chyba při přehrání audia:', e);
                            index++;
                            playNext();
                        });
                } else {
                    //   console.log('NO SOUND :(');
                }
            };

            playNext();
        }
    }, [answerStatus, question.audio1, question.audio2, question.audio3, quiz.type]);


    return (
        <div id="quiz-question">
            <QuestionView area={area} question={question} quiz={quiz} />


            {(() => {
                switch (quiz.type) {
                    //case 'spinner':

                    //case 'textCompletion':

                    case 'yesNo':
                        return (
                            <>
                                <h2 className="question" dangerouslySetInnerHTML={{ __html: question.question }} />
                                <InputYesNo question={question} handleAnswer={handleAnswer} answerStatus={answerStatus} />
                            </>
                        );
                    case '4options':
                        return (
                            <>
                                <h2 className="question">{question.question}</h2>
                                <Input4options question={question} handleAnswer={handleAnswer} answerStatus={answerStatus} />
                            </>
                        );
                    case 'writtenAnswer':
                        return (
                            <>
                                <h2 className="question">{question.question}</h2>
                                <InputWrittenAnswer question={question} handleAnswer={handleAnswer} answerStatus={answerStatus} />
                            </>
                        );

                    case 'audioSelect':
                        return <AudioSelectPlay question={question} handleAnswer={handleAnswer} answerStatus={answerStatus} />;
                    default:
                        return <></>;
                }
            })()}
        </div>
    );
};

export default Question;
